import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import useStyle from "./appBarStyle.js";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import LanguageIcon from "@mui/icons-material/Language";
import { changeTheme } from "../../redux/reduser/theme";
import Notifications from "@mui/icons-material/Notifications";
import { useNavigate } from "react-router-dom";
import Badge from "@mui/material/Badge";


import {  Menu } from "@mui/material";


import RecentNotifications from "../recentNotifications/RecentNotifications.jsx";


import { getNotificationsData } from '../../redux/reduser/notifications.js';
import moment from "moment";
export default function TopAppBar(props) {
  const { data, loading, error } = useSelector((state) => state.notifications);
  
const classes = useStyle();
  const [darkMode, setDarkMode] = useState(false);
  const themeMode = useSelector((state) => state.theme.themeMode);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    dispatch(getNotificationsData());
  }, []);
  const [anchorSetting, setAnchorSetting] = useState(null);
  const openSetting = Boolean(anchorSetting);
  const handleSettingClick = (event) => {
    setAnchorSetting(event.currentTarget);
  };
  const handleSettingClose = () => {
    setAnchorSetting(null);
  };
  const [anchorNotification, setAnchorNotification] = useState(null);
  const openNotification = Boolean(anchorNotification);
  const handleNotificationClick = (event) => {
    setAnchorNotification(event.currentTarget);
  };
  const handleNotificationClose = () => {
    setAnchorNotification(null);
  };
  
  function changeThemeMode() {
    setDarkMode(!darkMode);
    dispatch(changeTheme(darkMode ? "dark" : "light"));
  }


  function changeLanguge() {
    var lang = "";

    i18n.language == "ar" ? (lang = "en") : (lang = "ar");
    localStorage.setItem("lang", lang);
    i18n.changeLanguage(lang);
    // change date text language
    let locale = require('moment/locale/'+lang);
    moment.locale('tr',locale)
  }
// function settingMenu(){
//   const align=i18n.dir=="rtl"?"left":"right";
//   return     <Menu
//   anchorEl={anchorSetting}
//   id="account-menu"
  
//   open={openSetting}
//   onClose={handleSettingClose}
//   onClick={handleSettingClose}
//   PaperProps={{
//     elevation: 0,
//     sx: {
//       overflow: "visible",
//       filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
//       mt: 1.5,
//       borderRadius:5,
//       padding:1,
//       "& .MuiAvatar-root": {
//         width: 32,
//         height: 32,
//         ml: -0.5,
//         mr: 1,
//         borderRadius:5,
//       },
//       // "&:before": {
//       //   content: '""',
//       //   display: "block",
//       //   position: "absolute",
//       //   top: 0,
//       //   right: 13,
//       //   width: 15,
//       //   height: 15,
//       //   borderRadius:1,
//       //   bgcolor: "background.paper",
//       //   transform: "translateY(-50%) rotate(45deg)",
//       //   zIndex: 0,
//       // },
//     },
//   }}
//   // transformOrigin={{vertical: "top" }}
//   // anchorOrigin={{ horizontal: align, vertical: "bottom" }}
// >
//   <MenuItem onClick={changeThemeMode} >
//     <ListItemIcon  > 
//       {themeMode == "light" ? (
//         <DarkModeIcon
//        color="secondary"
        
//         >
 
//         </DarkModeIcon>
//       ) : (
//         <LightModeIcon
//          color="secondary"
         
//         ></LightModeIcon>
//       )}
//     </ListItemIcon>
//     {themeMode == "light" ?t("changeToDarkTheme"):t("changeToLightTheme")}
//   </MenuItem>
//   <MenuItem onClick={changeLanguge}>
//     <ListItemIcon   >
//       <LanguageIcon
//   color="secondary"
      
//       ></LanguageIcon>
//     </ListItemIcon>
//     {t("changeLanguage")}
//   </MenuItem>


//   {props.loginPage ? null :
//   <MenuItem onClick={logOut} >
//     <ListItemIcon >
//       <ExitToAppIcon  color="secondary" />
//     </ListItemIcon>
//     {t("logout")}
//   </MenuItem>
//   }
// </Menu>
// }
function notificationMenu(){
  const align=i18n.dir=="rtl"?"left":"right";
  return     <Menu
  anchorEl={anchorNotification}
  id="notification-menu"
  
  open={openNotification}
  onClose={handleNotificationClose}
  onClick={handleNotificationClose}
  PaperProps={{
    elevation: 0,
    sx: {
      overflow: "visible",
      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
      mt: 1.5,
      borderRadius:5,
      minWidth:200,
     
      padding:1,
      "& .MuiAvatar-root": {
        width: 32,
        height: 32,
        ml: -0.5,
        mr: 1,
        borderRadius:5,
      },
      // "&:before": {
      //   content: '""',
      //   display: "block",
      //   position: "absolute",
      //   top: 0,
      //   right: 13,
      //   width: 15,
      //   height: 15,
      //   borderRadius:1,
      //   bgcolor: "background.paper",
      //   transform: "translateY(-50%) rotate(45deg)",
      //   zIndex: 0,
      // },
    },
  }}
  // transformOrigin={{vertical: "top" }}
>
< RecentNotifications data={data.slice(0, 4)}/>
</Menu>
}
  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position={props.position} color={props.color} 
      className={classes.appBar}
       open={props.open} sx={{ boxShadow:props.color!=null?"none":null}}>
        <Toolbar>
          {props.loginPage ? null : (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerOpen}
              edge="start"
              sx={{ mr: 2, ...(props.open && { display: "none" }) }}
            >
              <Box className={classes.iconBox}><MenuIcon className={classes.menuIcon} />
              </Box>
            </IconButton>
          )}
          
           
          <Typography
            variant="body"
            component="div"
            sx={{ flexGrow: 1, mr: "18px" ,color:"white"}}
          >
            { props.loginPage ? "" :t("adminPanel")}
          </Typography>
          
 
         {notificationMenu()}
         <Box className={classes.iconBox}>
         <LanguageIcon
    className={classes.icon}
    onClick={changeLanguge}
      
      ></LanguageIcon>
      </Box>
         
              <Box className={classes.iconBox}>
              {themeMode == "light" ? (
        <DarkModeIcon
      className={classes.icon}
      onClick={changeThemeMode}
        
        >
 
        </DarkModeIcon>
      ) : (
        <LightModeIcon
        className={classes.icon}
        onClick={changeThemeMode}
         
        ></LightModeIcon>
      )}
                  </Box>
                  {props.loginPage ? null : (
                <Box >
            <Badge badgeContent={4} className={classes.badge} color="secondary" >
              <Notifications className={classes.notiIcon}  onClick={handleNotificationClick}/>
            </Badge>
            </Box>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
